import { Configuration } from '@Types/configuration.types';
import {
	ConfigurationParams,
	ConfigurationParamsWithSensorId,
	MultipleDeleteParams,
	PaginatedConfigurations,
	SensorConfigFormShape,
} from '@Types/configurations.types';
import { addNamespace } from '@Utils/actions';
import { StylovyzeTableRow } from '@innovyze/stylovyze';
import { createAction } from '@reduxjs/toolkit';
import {
	ConfigurationParamsRfi,
	CreateConfigurationParams,
	DeleteConfigurationParams,
} from './../types/configurations.types';

// Get Sensor Configuration By Sensor Id
export const getConfigurationById =
	createAction<ConfigurationParamsWithSensorId>(
		addNamespace('configurations/getConfigurationById'),
	);
export const getConfigurationByIdResolved = createAction<Configuration>(
	addNamespace('configurations/getConfigurationById/resolved'),
);
export const getConfigurationByIdRejected = createAction(
	addNamespace('configurations/getConfigurationById/rejected'),
);

// Get Sensor Configuration Details By Sensor Id
export const selectConfiguration = createAction<{ sensorId: string }>(
	addNamespace('configurations/selectOne'),
);
export const getConfigurationDetails =
	createAction<ConfigurationParamsWithSensorId>(
		addNamespace('configurations/getConfigurationDetails'),
	);
export const getConfigurationDetailsResolved = createAction<Configuration>(
	addNamespace('configurations/getConfigurationDetails/resolved'),
);
export const getConfigurationDetailsRejected = createAction(
	addNamespace('configurations/getConfigurationDetails/rejected'),
);

// Get Sensor Configurations
export const getConfigurations = createAction<ConfigurationParams>(
	addNamespace('configurations/getConfigurations'),
);
export const getConfigurationsResolved = createAction<PaginatedConfigurations>(
	addNamespace('configurations/getConfigurations/resolved'),
);
export const getConfigurationsRejected = createAction(
	addNamespace('configurations/getConfigurations/rejected'),
);

// ? Get Sensor Configurations RFI
export const getSensorsRfiFile = createAction<ConfigurationParamsRfi>(
	addNamespace('sensors/file/rfi/get'),
);

// Create New Sensor Configuration
export const createConfiguration = createAction<SensorConfigFormShape>(
	addNamespace('configurations/createConfiguration'),
);
export const createConfigurationResolved =
	createAction<CreateConfigurationParams>(
		addNamespace('configurations/createConfiguration/resolved'),
	);

export const createConfigurationRejected = createAction<{
	errorCategory?: string;
	errorMsg?: string;
}>(addNamespace('configurations/createConfiguration/rejected'));

export const resetCreateConfigurationStatus = createAction(
	addNamespace('configurations/resetCreateConfigurationStatus'),
);

// Update Sensor Configuration
export const updateConfiguration = createAction<{
	configurationId: string;
	payload: SensorConfigFormShape;
}>(addNamespace('configurations/updateConfiguration'));
export const updateConfigurationResolved = createAction<Configuration>(
	addNamespace('configurations/updateConfiguration/resolved'),
);

export const updateConfigurationRejected = createAction(
	addNamespace('configurations/updateConfiguration/rejected'),
);

export const mapConfigurationToSensor = createAction<Configuration>(
	addNamespace('configurations/mapConfigurationToSensor'),
);

// Update Sensor Configuration Search Criteria
export const changeSensorConfigurationSearchValue = createAction<string>(
	addNamespace('configurations/changeSensorConfigurationSearchValue'),
);

// Update Sensor Configuration Phyiscal Or Virtual
export const changeSensorConfigurationPhysicalFilter = createAction<string>(
	addNamespace('configurations/changeSensorConfigurationPhysicalFilter'),
);

// Update sensor types filter
export const changeSensorTypesFilter = createAction<string[]>(
	addNamespace('configurations/changeSensorTypesFilter'),
);
export const changeDataSourceTypesFilter = createAction<string[]>(
	addNamespace('configurations/changeDataSourceTypesFilter'),
);
// Delete Sensor Configuration
export const deleteConfiguration = createAction<
	Pick<DeleteConfigurationParams, 'sensorId'>
>(addNamespace('configurations/deleteConfiguration'));
export const deleteConfigurationResolved = createAction<
	Pick<DeleteConfigurationParams, 'sensorId'>
>(addNamespace('configurations/deleteConfiguration/resolved'));
export const deleteConfigurationRejected = createAction(
	addNamespace('configurations/deleteConfiguration/rejected'),
);
export const getSensorsReadingsCount = createAction<
	Partial<ConfigurationParamsRfi>
>(addNamespace('configurations/getSensorsReadingsCount'));

export const deleteMultipleConfigurations = createAction<MultipleDeleteParams>(
	addNamespace('configurations/deleteMultipleConfigurations'),
);

export const deleteMultipleConfigurationsResolved =
	createAction<MultipleDeleteParams>(
		addNamespace('configurations/deleteMultipleConfigurationsResolved'),
	);

export const deleteMultipleConfigurationsRejected = createAction(
	addNamespace('configurations/deleteMultipleConfigurationsRejected'),
);

export const headerCheckboxChange = createAction<boolean>(
	addNamespace('configurations/headerCheckboxChange'),
);

export const rowCheckboxChange = createAction<{
	row: StylovyzeTableRow;
	checked: boolean;
}>(addNamespace('configurations/rowCheckboxChange'));

export const rowSelectionModelChange = createAction<string[]>(
	addNamespace('configurations/rowSelectionModelChange'),
);

export const checkOrUncheckedRowsChange = createAction<string[]>(
	addNamespace('configurations/checkOrUncheckedRowsChange'),
);

export const headerCheckboxCheckedChange = createAction<boolean>(
	addNamespace('configurations/headerCheckboxCheckedChange'),
);

export const paginationModelChange = createAction<{
	page?: number;
	pageSize?: number;
}>(addNamespace('configurations/paginationModelChange'));

export const restoreConfigurationByIdStatus = createAction(
	addNamespace('configurations/restoreConfigurationByIdStatus'),
);
